module.exports = __webpack_public_path__ + "media/images/front/brands/atelier/atelier_header_2_m-0f4f13ccb50191778e296fd2c449e694.jpg";